import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  pageHeader: {
    margin: '0 auto',
    textAlign: 'center',
  },
  pageHeaderText: {
    marginBottom: 30,
    [breakpoints.down(640)]: {
      marginBottom: 20,
    },
  },
  pageHeaderChip: {
    height: 50,
    padding: '0 30px 0 20px',
    borderRadius: 25,
    fontSize: 18,
    fontWeight: 500,
    color: palette.primary.main,
    backgroundColor: '#ffefe5',
  },
  pageHeaderChipIcon: {
    color: palette.primary.main,
  },
  pageHeaderChipLabel: {
    paddingTop: 2,
    '@supports (-webkit-touch-callout: none)': {
      paddingTop: 0,
    },
  },
}));
